const Main = () => import('../../pages/main')
export default {
	path: '/contract',
	component: Main,
	meta: {
		sideNav: true
	},
	children: [
		{
			name: 'contract',
			path: 'index',
			component: () => import('../../pages/Contract'),
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '合同管理',
				icon: 'icon-nav icon-nav-contract'
			}
		}
	]
}
